<div class="confirm-del-container">
    <div class="header">
        <h4>DELETE MAP CONFIRMATION</h4>
    </div>

    <div class="confirm-del-content">
        <p class="support-info mt-2 text-center text-white" style="font-weight: 600;">
            *If Someone In Your Group / Party Are Interested In Taking Over Map Administration, Please<br>
            Contact <a href="mailto:support@worldtumbler.com" style="color: #6edaff; text-decoration: underline;">support&#64;worldtumbler.com</a> And We Will Assist With Reassignment.<br>
            <span style="font-size: 10px; font-weight: normal;">*User Must Have Adequate Appropriate Subscription Level</span>
        </p>

        <h5 class="subtitle text-center text-danger text-uppercase mt-4" style="font-weight: 700;">BECAUSE THIS ACTION CANNOT BE UNDONE, PLEASE CONFIRM EACH</h5>

        <p class="mb-3 text-white" style="font-weight: 600; font-size: 16px;">This Action Will:</p>

        <div class="confirmation-list text-white mb-4 mx-auto" style="width: 80%; font-weight: 600; font-size: 16px;">
            <div class="form-check custom-checkbox mb-2 d-flex align-items-center">
                <input class="form-check-input" type="checkbox" id="confirmWorldMap" [(ngModel)]="confirmWorldMap" style="width: 20px; height: 20px; cursor: pointer;">
                <label class="form-check-label ms-3" for="confirmWorldMap" style="cursor: pointer;">Delete {{ mapName }} World Map</label>
            </div>
            <div class="form-check custom-checkbox mb-2 d-flex align-items-center">
                <input class="form-check-input" type="checkbox" id="confirmWiki" [(ngModel)]="confirmWiki" style="width: 20px; height: 20px; cursor: pointer;">
                <label class="form-check-label ms-3" for="confirmWiki" style="cursor: pointer;">Delete {{ mapName }} Wiki pages</label>
            </div>
            <div class="form-check custom-checkbox mb-2 d-flex align-items-center">
                <input class="form-check-input" type="checkbox" id="confirmGames" [(ngModel)]="confirmGames" style="width: 20px; height: 20px; cursor: pointer;">
                <label class="form-check-label ms-3" for="confirmGames" style="cursor: pointer;">Delete All {{ mapName }} Games and Associated Game Journal Entries</label>
            </div>
            <div class="form-check custom-checkbox mb-2 d-flex align-items-center">
                <input class="form-check-input" type="checkbox" id="confirmCharacters" [(ngModel)]="confirmCharacters" style="width: 20px; height: 20px; cursor: pointer;">
                <label class="form-check-label ms-3" for="confirmCharacters" style="cursor: pointer;">Delete All {{ mapName }} Characters and Associated Character Journal Entries</label>
            </div>
        </div>

        <p class="vault-info mt-4 text-center text-white" style="font-weight: 600; font-size: 16px;">
            Content Created In This Map Will Remain In Your Content Vault And Available For Other Maps.
        </p>

    </div>

    <div class="btn-sec" style="justify-content: center; gap: 15px;">
        <button class="btn btn-theme" style="width: 140px; padding: 10px; font-size: 18px;" (click)="cancel()">Cancel</button>
        <button class="btn btn-green" style="width: 140px; padding: 10px; font-size: 18px;" (click)="confirmDelete()" [disabled]="!canDelete">Proceed</button>
        <button class="btn btn-green" style="width: 140px; padding: 10px; font-size: 18px;" (click)="subscribe()">Subscribe</button>
    </div>
</div>
